export default __webpack_public_path__ + "static/media/notFound.8b51736e.svg";